import { render, staticRenderFns } from "./pubRedbook.vue?vue&type=template&id=1abf1c88&scoped=true"
import script from "./pubRedbook.vue?vue&type=script&lang=js"
export * from "./pubRedbook.vue?vue&type=script&lang=js"
import style0 from "./pubRedbook.vue?vue&type=style&index=0&id=1abf1c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf1c88",
  null
  
)

export default component.exports